export const abuseReportTranslations = {
  en: {
    searchReporterPlaceholder: "Search by reporter name",
    selectReportTypePlaceholder: "Select report type",
    resetFiltersTooltip: "Reset filters",
    loadingText: "Loading...",
    tableReportedCard: "Reported Card",
    tableReportsCount: "Reports Count",
    tableLastReportedAt: "Last Reported At",
    tableAction: "Action",
    noReportsFound: "No reports found",
    showingRecords: "Showing {{start}} to {{end}} of {{total}} cards",
    modalReportsFor: "Reports Details",
    reporterLabel: "Reporter:",
    emailLabel: "Email:",
    reasonLabel: "Reason:",
    createdAtLabel: "Created At:",
    closeButton: "Close"
  },
  de: {
    searchReporterPlaceholder: "Nach Melder suchen",
    selectReportTypePlaceholder: "Berichtstyp auswählen",
    resetFiltersTooltip: "Filter zurücksetzen",
    loadingText: "Wird geladen...",
    tableReportedCard: "Gemeldete Karte",
    tableReportsCount: "Anzahl der Meldungen",
    tableLastReportedAt: "Zuletzt gemeldet am",
    tableAction: "Aktion",
    noReportsFound: "Keine Berichte gefunden",
    showingRecords: "Zeige {{start}} bis {{end}} von {{total}} Karten",
    modalReportsFor: "Berichte für",
    reporterLabel: "Melder:",
    emailLabel: "E-Mail:",
    reasonLabel: "Grund:",
    createdAtLabel: "Erstellt am:",
    closeButton: "Schließen"
  },
  hr: {
    searchReporterPlaceholder: "Pretraži po imenu prijavitelja",
    selectReportTypePlaceholder: "Odaberite vrstu prijave",
    resetFiltersTooltip: "Poništi filtre",
    loadingText: "Učitavanje...",
    tableReportedCard: "Prijavljena kartica",
    tableReportsCount: "Broj prijava",
    tableLastReportedAt: "Zadnja prijava",
    tableAction: "Radnja",
    noReportsFound: "Nema pronađenih prijava",
    showingRecords: "Prikazujem od {{start}} do {{end}} od ukupno {{total}} kartica",
    modalReportsFor: "Prijave za",
    reporterLabel: "Prijavitelj:",
    emailLabel: "E-pošta:",
    reasonLabel: "Razlog:",
    createdAtLabel: "Datum prijave:",
    closeButton: "Zatvori"
  }
};
